<template>
	<!-- 订舱管理 -->
	<div class="page-container" id="ebOrderContainer">
		<el-form ref="ebFtPlanFormRef" class="form-panel" label-position="top">
			<!-- 高级查询-start -->
			<el-row class="content-panel">
				<span class="span-text">高级查询</span>
				<el-row :gutter="10" style="margin:5px">
					<el-col :span="6">
						<el-form-item label="船公司:">
							<el-associate style="width: 100%;" :columns="associate_columns_carrier"
								:query-method="associate_queryMethod_carrier" class="input_length" clearable
								:query-length="0" :default-first-option="true" label-prop="custNameCn"
								value-prop="custAlias" placeholder="" v-model="searchData.carrierName" size="mini" />
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-row>
							<el-col :span="16">
								<el-form-item label="船名/航次:">
									<el-associate style="width: 100%;" :columns="associate_columns_vessel"
										:query-method="associate_queryMethod_vessel" class="input_length" clearable
										:query-length="0" :default-first-option="true" label-prop="vesselNameCn"
										value-prop="vesselNameCn" placeholder="" v-model="searchData.vesselNameEn"
										size="mini" name="vesselNameEn" />
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item>
									<label slot="label" class="label_no"></label>
									<el-input size="mini" placeholder="" clearable v-model="searchData.voyage">
									</el-input>
									<!--<el-associate style="width: 100%;"
                                  :columns="associate_columns_voyage"
                                  :query-method="associate_queryMethod_voyage"
                                  class="input_length"
                                  clearable
                                  :query-length="0"
                                  :default-first-option="true"
                                  label-prop="voyage"
                                  value-prop="voyage"
                                  placeholder=""
                                  v-model="searchData.voyage"
                                  size="mini"
                                  name="voyage"
                    />-->
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="6">

						<el-form-item label="订单号:">
							<el-input size="mini" v-model="searchData.orderNo"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">

						<el-form-item label="提单号:">
							<el-input size="mini" v-model="searchData.mblNo"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				<el-row :gutter="10" style="margin:5px">
					<el-col :span="6">
						<el-form-item label="创建日期从:">
							<el-date-picker v-model="searchData.startTime" align="right" type="date" style="width:100%;"
								size="mini" placeholder="" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="创建日期到:">
							<el-date-picker v-model="searchData.endTime" align="right" type="date" style="width:100%;"
								size="mini" placeholder="" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12" style="padding-top:17px;">
						<el-row type="flex" justify="end" align="middle" :gutter="10" class="el-row-margin">
							<el-button type="primary" size="small" plain @click="queryAllMore">查询</el-button>
							<el-button type="info" size="small" plain @click="resetMoreForm">重置</el-button>
						</el-row>
					</el-col>
				</el-row>
			</el-row>
			<!-- 高级查询-end -->
			<!-- 按钮栏-start -->
			<el-row style="margin-top: 15px">
				<el-button type="info" size="small" plain @click="">同步至舱单</el-button>
			</el-row>
			<!-- 按钮栏-end -->
			<!-- 表格-start -->
			<el-row style="margin-top: 15px">
				<hot-table ref="ebFtPlanTableRef" :data-source="ebFtPlanTableDataSource"
					:settings="ebFtPlanTableSettings" col-settings-key="ebFtPlan">
					<hot-column :has-tip="true" data="ebFtPlanId" title="操作" width="120">
						<column_do_renderer hot-renderer></column_do_renderer>
					</hot-column>
					<hot-column :has-tip="true" data="custBizNo" title="客户业务编号" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="orderNo" title="订单号" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="mblNo" title="提单号" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="vesselName" title="船名" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="voyage" title="航次" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="voyage" title="航次" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="carrierName" title="船公司" width="150">
					</hot-column>
					<hot-column :has-tip="true" data="createTime" date-format="yyyy-MM-DD HH:mm:ss" title="创建时间"
						width="150">
					</hot-column>
				</hot-table>
				</hot-table>
				<!-- 分页start -->
				<div class="pg_div">
					<el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
						:page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
						@current-change="handleCurrentChange" @size-change="handleSizeChange" />
				</div>
				<!-- 分页end -->
			</el-row>
			<!-- 表格-end -->
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import ResizeObserver from "resize-observer-polyfill"

	import {
		queryCarrierInfo,
		queryDictRows,
		queryPoInfo,
		queryVesselInfo
	} from "@/api/commonService";
	import columnDoRenderer from "@/components/CustomRenderer/columnDoRenderer"
	import {
		queryByConditions,
		queryMoreByConditions,
		queryAllEbftPlan,
		queryMoreEbFtPlan,
		queryMoreEbOrderForManifest
	} from "@/api/manifest";

	import templateBookingUpBox from '@/views/booking/TemplateBookingUpBox'
	import uploadGuaranteeUpBox from '@/views/booking/UploadGuaranteeUpBox'
	import downloadAttachchUpBox from '@/views/booking/DownloadAttachmentUpBox'

	export default {
		name: 'manage',
		components: {
			column_do_renderer: columnDoRenderer,

		},
		data() {
			return {
				resizeObserver: null,
				//查询条件
				no: '',
				//查询
				searchData: {
					carrierName: '',
					vesselNameEn: '',
					voyage: '',
					startTime: '',
					endTime: '',
					mblNo: '',
					orderNo: '',
				},
				//搜索框
				formData: {
					deployPort: ''
				},
				//标志点击哪个查询按钮
				queryButton: 0,
				//显示高级查询
				moreInfoVisible: false,
				//tab状态栏
				activeName: 'all',
				//各订单状态数量
				count0: 0,
				//新增弹出框状态
				addVisible: false,
				//勾选数据
				selectedData: {},
				//传递给复制/新增
				addOrCopyData: {},
				//状态列表
				ebftPlanApprovalStatusList: [],
				// 表格数据
				ebFtPlanTableDataSource: [],
				//当前行数据
				currentEbOrder: {},
				// 表格设置
				ebFtPlanTableSettings: {
					height: 360,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig
				},
				// 分页
				pageConfig: {
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					pageSize: 10,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [10, 20, 50, 100]
				},
				// 船公司联想控件
				associate_columns_carrier: [{
						title: "中文简称",
						field: 'custAlias'
					},
					{
						title: "中文全称",
						field: 'custNameCn'
					},
					{
						title: "助记码",
						field: 'mnemonicCode'
					}
				],
				// 船名联想控件
				associate_columns_vessel: [{
						title: "中文名称",
						field: 'vesselNameEn'
					},
					{
						title: "英文名称",
						field: 'vesselNameCn'
					},
					{
						title: "助记码",
						field: 'mnemonicCode'
					}
				],
				// 航次联想控件
				associate_columns_voyage: [{
					title: "航次",
					field: 'voyage'
				}],
				// 装/卸货港联想控件
				associate_columns_po: [{
						title: "英文名称",
						field: 'portNameEn'
					},
					{
						title: "中文名称",
						field: 'portNameCn'
					},
					{
						title: "国家代码",
						field: 'countryCode'
					},
					{
						title: "海港代码",
						field: 'portCode'
					}
				],
				//日期设置
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
			};
		},
		async created() {

		},
		mounted() {
			let self = this
			self.queryApprovalStatus()

			// 监听外层容器div宽度的变化，做表格自适应
			self.resizeObserver = new ResizeObserver(entries => {
				self.$nextTick(() => {
					self.$refs.ebFtPlanTableRef.resizeTo(entries[0].target.clientWidth - 32)
				})
			})
			self.resizeObserver.observe(document.getElementById("ebOrderContainer"))
		},
		methods: {
			// 船公司联想控件数据源
			associate_queryMethod_carrier({
				keyword,
				pageSize,
				currentPage
			}) {
				let params = {}
				if (keyword === '') {
					params = {
						custType4: "%SO%",
						isDeleted6: "0"
					}
				} else {
					params = {
						custAlias0: "%" + keyword + "%",
						custNameCn1: "%" + keyword + "%",
						custType4: "%SO%",
						isDeleted6: "0",
						mdmCustCode3: "%" + keyword + "%",
						mnemonicCode2: "%" + keyword + "%",
					}
				}

				let data = {
					action: "query",
					crudType: "SELECT",
					sorting: ["CTS_ILPCsCust.custNameCn"],
					mainModelName: "CTS_ILPCsCust",
					tag: "CTS_WEB_es",
					where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
					currentPage: currentPage,
					pageSize: pageSize,
					returnPage: true,
					returnTotal: false,
					reqArgs: params,
					fields: [
            "CTS_ILPCsCust.csCustId",
            "CTS_ILPCsCust.custAlias",
            "CTS_ILPCsCust.custNameCn",
            "CTS_ILPCsCust.custNameEn",
            "CTS_ILPCsCust.customsRegisteredNo",
            "CTS_ILPCsCust.esCustType",
            "CTS_ILPCsCust.isActive",
            "CTS_ILPCsCust.isBlacklist",
            "CTS_ILPCsCust.isCustomer",
            "CTS_ILPCsCust.isDeleted",
            "CTS_ILPCsCust.isOneTimeCustomer",
            "CTS_ILPCsCust.isSettlement",
            "CTS_ILPCsCust.isSupplier",
            "CTS_ILPCsCust.legalPerson",
            "CTS_ILPCsCust.mdmCustCode",
            "CTS_ILPCsCust.mobileNo",
            "CTS_ILPCsCust.postCode"
					],
					enableCascade: true
				}
				return new Promise(resolve => {
					queryCarrierInfo(data).then(res => {
						console.log("queryCarrierInfo", res)
						resolve({
							records: res.data.data,
							total: res.data.totalRecord
						})
					})
				}).catch(err => {
					console.log(err)
				})
			},
			// 船名联想控件数据源
			associate_queryMethod_vessel({
				keyword,
				pageSize,
				currentPage
			}) {
				let params = {}
				if (keyword === '') {
					params = {
						isDeleted3: "0"
					}
				} else {
					params = {
						vesselNameEn0: "%" + keyword + "%",
						vesselNameCn1: "%" + keyword + "%",
						mnemonicCode2: "%" + keyword + "%",
						isDeleted3: "0"
					}
				}

				let data = {
					action: "query",
					crudType: "SELECT",
					sorting: ["CTS_ILPMdVessel.vesselNameEn"],
					mainModelName: "CTS_ILPMdVessel",
					tag: "CTS_ILP_es",
					where: "(((CTS_ILPMdVessel.vesselNameEn LIKE :vesselNameEn0 OR CTS_ILPMdVessel.vesselNameCn LIKE :vesselNameCn1) OR CTS_ILPMdVessel.mnemonicCode LIKE :mnemonicCode2) AND CTS_ILPMdVessel.isDeleted = :isDeleted3)",
					currentPage: currentPage,
					pageSize: pageSize,
					returnPage: true,
					returnTotal: false,
					reqArgs: params,
					fields: ["CTS_ILPMdVessel.mdVesselId", "CTS_ILPMdVessel.vesselCarrierName",
						"CTS_ILPMdVessel.appCode", "CTS_ILPMdVessel.vesselType", "CTS_ILPMdVessel.unCode",
						"CTS_ILPMdVessel.creatorName", "CTS_ILPMdVessel.lastModifyOfficeName",
						"CTS_ILPMdVessel.lastModifyOffice", "CTS_ILPMdVessel.creatorId",
						"CTS_ILPMdVessel.vesselAttribute", "CTS_ILPMdVessel.vesselNameEn",
						"CTS_ILPMdVessel.principalGroupCode", "CTS_ILPMdVessel.callSign",
						"CTS_ILPMdVessel.recordVersion", "CTS_ILPMdVessel.isDeleted", "CTS_ILPMdVessel.createTime",
						"CTS_ILPMdVessel.lastModifierId", "CTS_ILPMdVessel.createOfficeName",
						"CTS_ILPMdVessel.vesselCarrierId", "CTS_ILPMdVessel.lastModifierName",
						"CTS_ILPMdVessel.vesselNameCn", "CTS_ILPMdVessel.imoNo", "CTS_ILPMdVessel.isActive",
						"CTS_ILPMdVessel.createOffice", "CTS_ILPMdVessel.mnemonicCode",
						"CTS_ILPMdVessel.customsVesselName", "CTS_ILPMdVessel.countryCode",
						"CTS_ILPMdVessel.countryNameCn", "CTS_ILPMdVessel.lastModifyTime"
					],
					enableCascade: true
				}
				return new Promise(resolve => {
					queryVesselInfo(data).then(res => {
						console.log("res", res)
						resolve({
							records: res.data.data,
							total: parseInt(res.data.totalRecord)
						})
					})
				}).catch(err => {
					console.log(err)
				})
			},

			// 航次联想控件数据源
			associate_queryMethod_voyage({
				keyword,
				pageSize,
				currentPage
			}) {

			},
			// 装/卸货港联想控件数据源
			associate_queryMethod_po({
				keyword,
				pageSize,
				currentPage
			}) {
				let params = {}
				if (keyword === '') {
					params = {
						portType4: ["OP", "IP"],
						isDeleted5: "0"
					}
				} else {
					params = {
						portNameEn0: "%" + keyword + "%",
						portNameCn1: "%" + keyword + "%",
						countryCode2: "%" + keyword + "%",
						portCode3: "%" + keyword + "%",
						portType4: ["OP", "IP"],
						isDeleted5: "0"
					}
				}

				let data = {
					action: "query",
					crudType: "SELECT",
					sorting: ["CTS_ILPMdPort.portNameEn"],
					mainModelName: "CTS_ILPMdPort",
					tag: "CTS_ILP_es",
					where: "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
					currentPage: currentPage,
					pageSize: pageSize,
					returnPage: true,
					returnTotal: false,
					reqArgs: params,
					fields: ["CTS_ILPMdPort.mdPortId", "CTS_ILPMdPort.createOffice", "CTS_ILPMdPort.lastModifyOffice",
						"CTS_ILPMdPort.lastModifyOfficeName", "CTS_ILPMdPort.lastModifierId",
						"CTS_ILPMdPort.areaCode", "CTS_ILPMdPort.lineNameCn", "CTS_ILPMdPort.portNameEn",
						"CTS_ILPMdPort.principalGroupCode", "CTS_ILPMdPort.customsCode", "CTS_ILPMdPort.isActive",
						"CTS_ILPMdPort.createOfficeName", "CTS_ILPMdPort.creatorName",
						"CTS_ILPMdPort.lastModifierName", "CTS_ILPMdPort.appCode", "CTS_ILPMdPort.longitude",
						"CTS_ILPMdPort.creatorId", "CTS_ILPMdPort.recordVersion", "CTS_ILPMdPort.lastModifyTime",
						"CTS_ILPMdPort.portNameCn", "CTS_ILPMdPort.portCode", "CTS_ILPMdPort.createTime",
						"CTS_ILPMdPort.isDeleted", "CTS_ILPMdPort.iataCode", "CTS_ILPMdPort.latitude",
						"CTS_ILPMdPort.lineId", "CTS_ILPMdPort.countryName", "CTS_ILPMdPort.countryCode",
						"CTS_ILPMdPort.portType"
					],
					enableCascade: true
				}
				return new Promise(resolve => {
					queryPoInfo(data).then(res => {
						console.log("res", res)
						resolve({
							records: res.data.data,
							total: parseInt(res.data.totalRecord)
						})
					})
				}).catch(err => {
					console.log(err)
				})
			},
			// pageSize 改变时会触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`)
				this.pageConfig.pageSize = val
				let self = this
				self.queryStatusPage(this.pageConfig.currentPage)
			},
			// currentPage 改变时会触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`)
				this.pageConfig.currentPage = val
				let self = this
				self.queryStatusPage(this.pageConfig.currentPage)
			},
			// 单击行事件
			rowClick(val) {
				let self = this
				self.currentEbOrder = val.record
			},
			// tab切换事件
			handleClick(tab, event) {
				let self = this
				self.pageConfig.currentPage = 1
				this.queryStatusPage()
			},
			queryStatusPage() {

			},

			//重置搜索框
			resetForm() {
				this.formData = {}
			},
			resetMoreForm() {
				this.searchData = {}
			},

			//查询所有
			queryAllMore() {
				let self = this
				let searchData = {
					carrierName: self.searchData.carrierName,
					vesselNameEn: self.searchData.vesselNameEn,
					voyage: self.searchData.voyage,
					startTime: self.searchData.startTime,
					endTime: self.searchData.endTime,
					polName: self.searchData.polName,
					podName: self.searchData.podName,
					page: self.pageConfig.currentPage,
					limit: self.pageConfig.pageSize,
				}
				queryMoreEbOrderForManifest(searchData).then(res => {
					if (res.data != null) {
						seft.ebFtPlanTableDataSource = res.data
					}
				})
			},
			//各舱单提交状态数量
			filterStatus(data) {
				let self = this

				self.count0 = data.length
				self.ebftPlanApprovalStatusList.forEach((item, index) => {
					if (data.length == 0) {
						self.ebftPlanApprovalStatusList[index].count = 0
					} else {
						self.ebftPlanApprovalStatusList[index].count = data.filter(item1 => {
							return item1.approvalStatus === item.value
						}).length
					}
				})
			},
			//获取订单提交状态数据字典
			queryApprovalStatus() {
				let self = this
				queryDictRows('MD_CODE_DICT$EB_FT_SUB_STATUS').then(res => {
					let dict = []
					res.MD_CODE_DICT$EB_FT_SUB_STATUS.forEach(item => {
						let param = {}
						param.name = item.value
						param.value = item.key
						param.count = 0
						dict.push(param)
					})
					self.ebftPlanApprovalStatusList = dict
					console.log("ebftPlanApprovalStatusList", dict)
					// 数据字典
					self.$hotTableUtils.registDict({
						'EB_FT_SUB_STATUS': dict
					})
				})
			},

			//点击
			clickModule(e) {

			},
		}
	};
</script>

<style scoped lang="less">

</style>
